import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { TableModel } from 'src/app/models/table.model';
import { Observable } from 'rxjs';
import { ContributorPaymentFilterModel } from '../models/contributor.payment.filter.model';
import { PagedContributorPaymentDetail } from '../models/paged.contributor.payment.detail';
import { isNullOrUndefined } from 'util';
import { ContributorPaymentLogFilterModel } from '../models/contributor.payment.log.filter.model';
import { PagedContributorPaymentLogDetail } from '../models/paged.contributor.payment.log.detail';
import { ContributorPaymentUpsertModel } from 'src/app/admin/models/contributer.payment.upsert.model';

@Injectable()
export class PaymentService {

    constructor(private http: HttpClient) { }

    GetContributorPayments(filterModel: ContributorPaymentFilterModel, tableModel: TableModel): Observable<PagedContributorPaymentDetail> {
        let url = `${environment.apiUrl}/api/admin/payment/contributor-payment-history`;
        const queryParams = [];
        const tempArr = [];
        if (!isNullOrUndefined(filterModel.contributorId)) {
            tempArr.push(`contributorId=${filterModel.contributorId}`);
        }
        if (!isNullOrUndefined(filterModel.year)) {
            tempArr.push(`year=${filterModel.year}`);
        }
        if (!isNullOrUndefined(filterModel.month)) {
            tempArr.push(`month=${filterModel.month}`);
        }
        if (tableModel) {
            queryParams.push(tableModel.toQueryString());
        }
        if (queryParams.length) {
            url += '?' + queryParams.join('&') + '&' + tempArr.join('&');
        }
        return this.http.get<PagedContributorPaymentDetail>(url);
    }

    GetContributorPaymentLogs(filterModel: ContributorPaymentLogFilterModel,
        tableModel: TableModel): Observable<PagedContributorPaymentLogDetail> {
        let url = `${environment.apiUrl}/api/admin/payment/contributor-payment-log`;
        const queryParams = [];
        const tempArr = [];
        if (!isNullOrUndefined(filterModel.contributorId)) {
            tempArr.push(`contributorId=${filterModel.contributorId}`);
        }
        if (!isNullOrUndefined(filterModel.year)) {
            tempArr.push(`year=${filterModel.year}`);
        }
        if (!isNullOrUndefined(filterModel.month)) {
            tempArr.push(`month=${filterModel.month}`);
        }
        if (tableModel) {
            queryParams.push(tableModel.toQueryString());
        }
        if (queryParams.length) {
            url += '?' + queryParams.join('&') + '&' + tempArr.join('&');
        }
        return this.http.get<PagedContributorPaymentLogDetail>(url);
    }

    getContributorRemainingAmount(contributorId: number): Observable<number> {
        return this.http.get<number>(`${environment.apiUrl}/api/admin/payment/contributor-remaining-amount/${contributorId}`);
    }
    addContributorPaymentLog(model: ContributorPaymentUpsertModel) {
        return this.http.post(`${environment.apiUrl}/api/admin/payment/add-contributor-payment`, model);
    }
}
